"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialPerformerTypes = exports.GroupPerformerTypeFilter = exports.GroupPerformerTypes = exports.RolePerformerClassification = exports.RolePerformerType = void 0;
const commercial_types_1 = require("./commercial-types");
/**
 * Role Performer Types - Subset needed for ClassifierService
 */
var RolePerformerType;
(function (RolePerformerType) {
    RolePerformerType["OnCameraPrincipal"] = "On Camera Principal";
    RolePerformerType["OffCameraPrincipal"] = "Off Camera Principal";
    RolePerformerType["Extra"] = "Extra";
    RolePerformerType["Radio"] = "Radio";
    RolePerformerType["AFM"] = "American Federation Of Musicians";
    RolePerformerType["OnCameraGroup"] = "On Camera Group";
    RolePerformerType["OnCameraGroupContractor"] = "On Camera Group Contractor (1-2)";
    RolePerformerType["OnCameraGroupContractor3To5"] = "On Camera Group Contractor (3-5)";
    RolePerformerType["OnCameraGroupContractor6To8"] = "On Camera Group Contractor (6-8)";
    RolePerformerType["OnCameraGroupContractor9Plus"] = "On Camera Group Contractor (9+)";
    RolePerformerType["OffCameraGroup"] = "Off Camera Group";
    RolePerformerType["OffCameraGroupContractor"] = "Off Camera Group Contractor (1-2)";
    RolePerformerType["OffCameraGroupContractor3To5"] = "Off Camera Group Contractor (3-5)";
    RolePerformerType["OffCameraGroupContractor6To8"] = "Off Camera Group Contractor (6-8)";
    RolePerformerType["OffCameraGroupContractor9Plus"] = "Off Camera Group Contractor (9+)";
})(RolePerformerType || (exports.RolePerformerType = RolePerformerType = {}));
var RolePerformerClassification;
(function (RolePerformerClassification) {
    RolePerformerClassification["OnCamera"] = "on_camera";
    RolePerformerClassification["OffCamera"] = "off_camera";
})(RolePerformerClassification || (exports.RolePerformerClassification = RolePerformerClassification = {}));
// from web/roleTypes - only one being used
exports.GroupPerformerTypes = [
    RolePerformerType.OnCameraGroup,
    RolePerformerType.OffCameraGroup,
];
exports.GroupPerformerTypeFilter = [
    RolePerformerType.OnCameraGroupContractor,
    RolePerformerType.OnCameraGroupContractor3To5,
    RolePerformerType.OnCameraGroupContractor6To8,
    RolePerformerType.OnCameraGroupContractor9Plus,
    RolePerformerType.OffCameraGroupContractor,
    RolePerformerType.OffCameraGroupContractor3To5,
    RolePerformerType.OffCameraGroupContractor6To8,
    RolePerformerType.OffCameraGroupContractor9Plus,
];
/**
 * Role Performer Types by Commercial
 */
exports.CommercialPerformerTypes = {
    [commercial_types_1.CommercialType.TV]: [
        RolePerformerType.OnCameraPrincipal,
        RolePerformerType.OnCameraGroup,
        RolePerformerType.OffCameraPrincipal,
        RolePerformerType.OffCameraGroup,
        RolePerformerType.Extra,
        RolePerformerType.AFM,
    ],
    [commercial_types_1.CommercialType.Radio]: [RolePerformerType.Radio, RolePerformerType.AFM],
};
//# sourceMappingURL=role-performer-types.js.map